// One rule for every proctoring warning limit, so the abort check (Test.jsx) and the warning
// modals can't disagree on the boundary. With a limit of N, N warnings are allowed and the
// (N+1)th of the same type aborts - the same boundary face-not-found and window switching
// already use (see faceNotFoundBudget.js, webproctoringcount in Test.jsx).
//
// A missing/invalid limit never aborts.

const toLimit = (limit) => {
  const n = Number(limit);
  return limit === null || limit === undefined || limit === "" || !Number.isFinite(n) ? null : n;
};

export const isWarningLimitExceeded = (limit, count) => {
  const n = toLimit(limit);
  return n !== null && count > n;
};

export const isLastWarning = (limit, count) => {
  const n = toLimit(limit);
  return n !== null && count === n;
};
